import React, { useState, useRef } from 'react'
import { Input, Button, message, Spin } from 'antd'
import { getUrlUploadArtwork } from '../../../services/api/3dApi'
import '../styles/index.scss'
import axios from 'axios'

const UploadArtworkContainer = () => {
    const [image, setImage] = useState('')
    const [type, setType] = useState('')
    const [size, setSize] = useState('')
    const [format, setFormat] = useState('')
    const [loading, setLoading] = useState(false)
    const [urlArtwork, setUrlArtwork] = useState('')

    const inputRef = useRef(null)

    const handleChangeInput = (field, value) => {
        if (field === 'type') return setType(value)
        setSize(value)
    }

    const handleClearForm = () => {
        setImage('')
        setType('')
        setSize('')
        setUrlArtwork('')
        inputRef.current.value = null
    }

    const handleChangeFile = (e) => {
        const file = e.target.files[0]
        if (file) {
            const reader = new FileReader()
            reader.onload = (event) => {
                const binaryData = event.target.result
                setImage(binaryData)
            }
            reader.readAsArrayBuffer(file)
        }
        if (file && file.name) setFormat(file.name.split('.')[1])
    }

    const handleUpload = async () => {
        setLoading(true)

        try {
            const payload = { type, size, format }
            const { data } = await getUrlUploadArtwork(payload)
            const { data: response } = data
            const { imageUrl, uploadUrl } = response
            if (uploadUrl) {
                const { status } = await axios.put(uploadUrl, image, {
                    headers: {
                        'Content-Type': 'image/jpeg',
                    }
                })
                if (status === 200) {
                    handleClearForm()
                    setLoading(false)
                    message.success('Upload Artwork successfully!')
                    setUrlArtwork(imageUrl)
                } else {
                    message.error('Upload Artwork failed!')
                    handleClearForm()
                    setLoading(false)
                }
            }
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Spin spinning={loading}>
            <div className='UploadArtworkContainer p-5'>
                <div className="row">
                    <div className="col-12 mx-auto">
                        <div className="d-flex col-5 justify-content-between px-0">
                            <h1>Upload Artwork</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <div className="infoUpload">
                            <div className="itemInfo">
                                <label htmlFor="type" className='font-weight-bold'>Type<span className='text-danger'>*</span></label>
                                <Input id="type" value={type} onChange={(e) => handleChangeInput('type', e.target.value)} />
                            </div>
                            <div className="itemInfo">
                                <label htmlFor="size" className='font-weight-bold'>Size<span className='text-danger'>*</span></label>
                                <Input id="size" value={size} onChange={(e) => handleChangeInput('size', e.target.value)} />
                            </div>
                            <div className="itemInfo">
                                <input ref={inputRef} type="file" onChange={handleChangeFile} accept="image/png, image/jpeg" />
                            </div>
                            {urlArtwork && <div className="itemInfo mt-2">
                                <Input.TextArea value={urlArtwork} style={{ minHeight: 205 }} />
                            </div>}
                        </div>
                        <div className="action-btn float-right mt-3">
                            <Button className='mx-2' onClick={handleClearForm}>Clear</Button>
                            <Button type="primary" onClick={handleUpload} disabled={!type || !size || !format}>Upload</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Spin>
    )
}

export default UploadArtworkContainer